import(/* webpackMode: "eager" */ "/vercel/path0/apps/PublicUI/app/(marketplace)/[educator_param]/[course_param]/not-found.tsx");
